import React, { useEffect } from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import { Icon } from "@amzn/meridian";
import checkCircleTokens from "@amzn/meridian-tokens/base/icon/check-circle";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import { useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "src/store/store";
import { getSiteInspectionHistory } from "src/store/inspectionSlice";
import "./landing.scss";

const HistoryView: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const completedInspections = useAppSelector((state) => state.inspection.completedSiteInspections);
  const activeSiteCode = useAppSelector((state) => state.user.activeSiteCode);

  // History is scoped to the currently selected site (not just the current
  // user's own inspections), so re-fetch whenever the selected site changes.
  useEffect(() => {
    if (!activeSiteCode) return;
    dispatch(getSiteInspectionHistory(activeSiteCode));
  }, [activeSiteCode, dispatch]);

  return (
    <Column spacing="400" spacingInset="none 500 500">
      <Text type="h300">History</Text>

      {/* Completed Inspections card */}
      <div onClick={() => navigate("/completedInspections")}>
        <Row className="home-card" alignmentVertical="center" widths={["fit", "fill", "fit"]} spacing="400" spacingInset="400">
          <Row spacingInset="300" className="home-workflow-icon-bg">
            <Icon tokens={checkCircleTokens} color="success" />
          </Row>
          <Column spacing="none">
            <Text type="b300">Completed Inspections</Text>
            <Text type="b100" color="secondary">{completedInspections.length} completed</Text>
          </Column>
          <Icon tokens={chevronRightSmallTokens} />
        </Row>
      </div>
    </Column>
  );
};

export default HistoryView;
